import {
  EXPENSES_ALL,
  EXPENSES_GET,
  EXPENSES_DEL,
  EXPENSES_PUT,
  EXPENSES_POST,
  EXPENSES_LOADING,
  EXPENSES_ERROR,
  EXPENSES_RESET,
  EXPENSES_PENDING_COUNT,
  EXPENSES_PAYMENT_APPROVAL_PENDING_COUNT,
  EXPENSES_REVIEW_PENDING_COUNT,
} from '../../actions/types';

const initialState = {
  expenses: null,
  isLoading: true,
  isCompleted: true,
  pendingCount: 0,
  paymentApprovalPendingCount: 0,
  reviewPendingCount: 0,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case EXPENSES_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
        pendingCount: state.pendingCount,
        paymentApprovalPendingCount: state.paymentApprovalPendingCount,
        reviewPendingCount: state.reviewPendingCount,
      };
    case EXPENSES_GET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case EXPENSES_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case EXPENSES_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      const currentSingleId = state._id || state.id;
      const isCurrentExpense =
        currentSingleId && payloadId && String(currentSingleId) === String(payloadId);
      return {
        ...state,
        // Only update scalar status — do NOT spread full payload to avoid overwriting populated refs
        ...(isCurrentExpense && action.payload?.status !== undefined
          ? { status: action.payload.status }
          : {}),
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case EXPENSES_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case EXPENSES_RESET:
      return {
        expenses: null,
        isLoading: true,
        isCompleted: true,
        pendingCount: state.pendingCount,
        paymentApprovalPendingCount: state.paymentApprovalPendingCount,
        reviewPendingCount: state.reviewPendingCount,
      };
    case EXPENSES_PENDING_COUNT:
      return { ...state, pendingCount: action.payload };
    case EXPENSES_PAYMENT_APPROVAL_PENDING_COUNT:
      return { ...state, paymentApprovalPendingCount: action.payload };
    case EXPENSES_REVIEW_PENDING_COUNT:
      return { ...state, reviewPendingCount: action.payload };
    case EXPENSES_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case EXPENSES_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
